import React from "react";

interface DataTableAnnouncerProps {
  /** Current announcement text; updating it announces politely. */
  announcement: string;
}

/**
 * Visually-hidden polite live region for master/detail tables. Render it once
 * and persistently (so it exists in the DOM before the first announcement),
 * fed by the debounced `announcement` from `useDataTableRowDetails`.
 *
 * The `<output>` element is used as a polite live region to maximize
 * accessibility support across devices, and the message is read as a whole at
 * the next pause without interrupting the focused-cell announcement.
 */
function DataTableAnnouncer({
  announcement,
}: Readonly<DataTableAnnouncerProps>) {
  return (
    <output aria-live="polite" aria-atomic="true" className="sr-only">
      {announcement}
    </output>
  );
}

export { DataTableAnnouncer };
export type { DataTableAnnouncerProps };
